<template>
    <component :is="template">
        <div>
            <div>
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">캐시내역</h2>
                </div>

                <v-divider class="d-md-none" />
                <div class="py-20px pt-md-0px pb-md-40px text-center">
                    <div class="tit tit--xs"><b class="black--text">{{ me?.name }}</b>님의 나누리 캐시</div>
                    <div class="mt-1"><b class="tit tit--lg primary--text font-weight-bold">{{ parseInt(+me?.cash || 0 ).format() }}</b> 원</div>
                </div>

                <div>
                    <v-data-table :items="cashes" :headers="cashesHeaders" hide-default-footer disable-pagination disable-sort>
                        <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                        <span slot="item.amount" slot-scope="{item}">{{ parseInt(+item.amount || 0).format() }}원</span>
                        <span slot="item.result" slot-scope="{item}">{{ parseInt(+item.result || 0).format() }}원</span>
                    </v-data-table>
                </div>
            </div>

            <div class="mt-30px mt-md-40px">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)"/>
            </div>
        </div>
    </component>
</template>
<script>
import api from "@/api";
export default {
    data(){
        return {
            page: 1,
            pageCount: 0,
            limit: 10,

            cashes: [],
            cashesHeaders: [
                { text: "캐시일자", value: "createdAt", align: "center", width: 200 },
                { text: "비고", value: "remark", align: "center" },
                { text: "금액", value: "amount", align: "center", width: 150 },
                { text: "남은금액", value: "result", align: "center", width: 150 },
            ],
            me: null
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;

            this.search();
        },
        async search(routable = false){
            let { summary, cashes } = await api.v1.me.cashes.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                }
            });

            this.cashes = cashes;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`); }
    }
}
</script>